import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import PersonAddIcon from '@mui/icons-material/PersonAdd';

import {
  Box,
  Button as Btn,
  Chip,
  CircularProgress,
  DialogActions,
  Divider,
  Grid,
  MenuItem,
  Pagination,
  Stack,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { Base } from '../../../components/v2/dialogs/Base';

import { ZorgMail } from '../../../models/ZorgMail';
import { User } from '../../../models/User';

const { DateTime } = require("luxon");

type Props = {}

export const CoachEditZorgMail: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();
  const { state } = useLocation();

  // !!state && !!state.mail => draft
  // state.reply => reply

  const [replyingTo, setReplyingTo] = useState<ZorgMail>();
  const [currentMail, setCurrentMail] = useState<ZorgMail>({});
  const [items, setItems] = useState<File[]>([]);
  const [savedItems, setSavedItems] = useState<{
    id: number;
    item_file_name: string;
    get_item: string;
  }[]>([]);
  const [skippedFirstSave, setSkippedFirstSave] = useState<boolean>(false);
  const [clientSearch, setClientSearch] = useState<string>('');
  const [clientUserSearch, setClientUserSearch] = useState<string>('');
  const [preloadClient, setPreloadClient] = useState<string>(state?.preload);
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [addingClient, setAddingClient] = useState<boolean>(false);
  const [saveToProfile, setSaveToProfile] = useState<boolean>(false);

  const [addContact, setAddContact] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [zmContacts, setZmContacts] = useState<any[]>([]);
  let count = 0;

  const {
    data: loadMail,
    isSuccess: loadMailSuccess,
    refetch: loadMailRefetch,
  } = useQuery({
    queryKey: ["zorg_load_mail", state?.load_id],
    queryFn: () =>
      fetch_one<ZorgMail>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'zorg_mail',
          fields: [
            'id', 'user_id', 'user', 'is_read', 'is_deleted', 'is_sending', 'is_sent', 'read', 'message_id', 'message_data', 'content', 'created_at'
          ],
          id: state?.load_id
        },
        login
      ),
    enabled: !!login && !!state?.load_id,
  });

  const {
    data: clients,
    isLoading: clientsLoading,
    isError: clientsError,
    isSuccess: clientsSuccess,
    // refetch: clientsRefetch,
  } = useQuery({
    queryKey: ["clients", 'full_bsn', currentPractice?.id, clientUserSearch],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: [
            'id', 'full_name', 'first_name', 'last_login_date', 'language_id', 'email', 'national_number', 'last_name', 'street', 'number', 'zip', 
            'city', 'birth_date', 'phone_mobile', 'gender', 'extra_data', 'country|id_name'
          ],
          order: "first_name ASC, last_name ASC",
          filter: {
            search: clientUserSearch,
            advanced: {
              for_practice: (login?.practice_id || currentPractice?.id),
              // enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      extra?: any;
    }) => {
      return fetch_one<{
        custom_result: {
          success: boolean,
          error?: string,
          mail?: ZorgMail,
          mail_id?: number,
          contacts?: any[]
        }
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
      extra?: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      // if (!!refetch) refetch();

      if (!!variables.extra?.goback) {
        navigate("/zorgmail_inbox");
      } else {
        if (!!variables.extra?.find_contacts) {
          setZmContacts(data.custom_result.contacts || []);
        } else {
          setCurrentMail({
            ...currentMail,
            id: data.custom_result.mail_id
          });
          // if (data.custom_result.mail.zorg_mail_attachments) {
          //   setItems([]);
          //   setSavedItems(data.custom_result.mail.zorg_mail_attachments);
          // }
        }
      }
    },
  });
  const mutationDelete = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: {
          success: boolean,
          error?: string,
          mail: ZorgMail
        }
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      navigate("/zorgmail_inbox");
    },
  });
  // const mutationSave = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //     addContact?: boolean
  //   }) => {
  //     return fetch_one<{
  //       custom_result: any
  //     }>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //     addContact?: boolean;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     if (!!variables.addContact) {
  //       let id = data.custom_result.id;
  //       if (!!id && (currentMail.to_ids || []).filter(fff => fff === id).length < 1) {
  //         setCurrentMail({
  //           ...currentMail,
  //           to_ids: [
  //             ...(currentMail.to_ids || []), id
  //           ]
  //         });
  //       }
  //     }
  //     setAddContact(false);
  //     // restrictedsRefetch();
  //   },
  // });








  const saveMail = (goback?: boolean, send?: boolean) => {
    if (currentMail) {
      if (!!skippedFirstSave) {
        mutationCustomAction.mutate({formData: {
          object: 'zorg_mail',
          class_action: 'custom_api_save_draft',
          ob: {
            ...currentMail
          },
          do_send: !!send ? 1 : 0,
          save_to_profile: !!saveToProfile ? 1 : 0
        }, extra: {goback: !!goback}});
      } else {
        setSkippedFirstSave(true);
      }
    }
    // if (!!currentMail) {
    //   // console.log(currentMail, currentMail.id);
    //   let data = new FormData();
    //   data.append('object', 'zorg_mail');
    //   data.append('class_action', 'custom_api_save_draft');
    //   if (!!currentMail) data.append('id', currentMail.id?.toString() || '');
    //   data.append('zorg_mail[to_id]', currentMail.to_id?.toString() || '');
    //   data.append('zorg_mail[subject]', currentMail.subject || '');
    //   data.append('zorg_mail[body]', currentMail.body || '');
    //   if ((currentMail.to_ids || []).length > 0) {
    //     (currentMail.to_ids || []).forEach((to_id, index) => {
    //       data.append(`zorg_mail[to_ids][]`, to_id?.toString());
    //     });
    //   } else {
    //     data.append(`zorg_mail[to_ids][]`, '');
    //   }
    //   if (items.length > 0) {
    //     items.forEach((file, index) => {
    //       data.append(`item${index}`, file);
    //     });
    //   }
    //   if (savedItems.length > 0) {
    //     savedItems.forEach((file, index) => {
    //       data.append(`existing_file_ids[]`, file.id.toString());
    //     });
    //   }
    //   data.append('send_email', !!currentMail.send_email ? '1' : '0');
    //   if (!!send) data.append('send', '1');
    //   if (!!replyingTo) data.append('reply_id', replyingTo.id?.toString() || '');
    //   [
    //     'id', 'to', 'from', 'read', 'replied', 'sent', 'is_draft', 'deleted', 'created_at', 'subject', 'body',
    //     'zorg_mail_attachments|count', 'zorg_mail_attachments', 'zorg_mail_recipients'
    //   ].forEach((word, index) => {
    //     data.append(`fields[]`, word);
    //   });
    //   ['id', 'full_name'].forEach((word, index) => {
    //     data.append(`sub_fields[to][]`, word);
    //   });
    //   ['id', 'full_name'].forEach((word, index) => {
    //     data.append(`sub_fields[from][]`, word);
    //   });
    //   ['id', 'get_item', 'item_file_name'].forEach((word, index) => {
    //     data.append(`sub_fields[zorg_mail_attachments][]`, word);
    //   });
    //   ['id', 'recipient', 'read', 'deleted', 'replied'].forEach((word, index) => {
    //     data.append(`sub_fields[zorg_mail_recipients][]`, word);
    //   });
    //   ['id', 'full_name'].forEach((word, index) => {
    //     data.append(`sub_fields[recipient][]`, word);
    //   });

    //   if (!!skippedFirstSave) {
    //     mutationCustomAction.mutate({formData: data, extra: {goback: !!goback}});
    //   } else {
    //     setSkippedFirstSave(true);
    //   }
    // }
  }

  useEffect(() => {
    if (!!state && !!state.reply) {
      setReplyingTo(state.reply);
      setCurrentMail({
        ...currentMail,
        to_ids: [state.reply.from?.id],
        message_data: {
          draft: {
            subject: `RE: ${state.reply.subject}`
          }
        }
      });
    } else {
      setReplyingTo(undefined);
    }
  }, [!!state && !!state.reply]);
  useEffect(() => {
    if (!!state && !!state.mail) {
      setFlickerEditor(true);
      setCurrentMail({
        ...state.mail,
        // @ts-ignore
        to_ids: (state.mail.zorg_mail_recipients || []).map(mm => mm.recipient?.id)
      });
      if (state.mail.zorg_mail_attachments) {
        setItems([]);
        setSavedItems(state.mail.zorg_mail_attachments);
      }
      setTimeout(() => {setFlickerEditor(false);}, 200);
    } else {
      
    }
  }, [!!state && !!state.mail]);
  useEffect(() => {
    let to = setTimeout(() => {
      saveMail();
    }, 1000);

    return () => {
      clearTimeout(to);
    }
  }, [currentMail?.message_data?.draft?.content]);
  useEffect(() => {
    let to = setTimeout(() => {
      mutationCustomAction.mutate({formData: {
        object: 'zorg_mail',
        class_action: 'custom_api_find_contact',
        search: clientSearch
      }, extra: {find_contacts: true}});
    }, 1000);

    return () => {
      clearTimeout(to);
    }
  }, [clientSearch]);
  useEffect(() => {
    if (!!loadMail && !!loadMail.id) {
      setCurrentMail(loadMail);
      setAddingClient(Object.values(loadMail?.message_data?.draft?.linked_client || {}).filter(fff => !!fff).length > 1);
    }
  }, [loadMail]);
  useEffect(() => {
    if (!!state?.linked_client) {
      setCurrentMail({
        ...currentMail,
        message_data: {
          ...(currentMail?.message_data || {}),
          draft: {
            ...(currentMail?.message_data?.draft || {}),
            linked_client: state.linked_client
          }
        }
      });
      setAddingClient(true);
    }
  }, [!!state && !!state.linked_client]);

  return <Page sx={{padding: {xs: 0, md: 3}}}>
    <Grid container spacing={1}>

      {!replyingTo && <Grid item xs={12}>
        <Button
          onClick={() => {
            setAddContact(true);
          }}
          id="add_external"
          contained
          label={t("shared.zorg_mail.find_contact")}
          sx={{
            marginTop: 1,
            marginBottom: 1
          }}
          startIcon={<PersonAddIcon />}
        />
      </Grid>}
      {!replyingTo && <Grid item xs={12}>
        <Typography sx={{fontSize: '14px'}}>{t("shared.zorg_mail.recipients", "Ontvangers")}</Typography>
        
        {(currentMail.message_data?.draft?.recipients || []).length < 1 && <Typography sx={{fontSize: '0.7rem', fontStyle: 'italic'}}>{t("shared.zorg_mail.no_recipients")}</Typography>}
        {(currentMail.message_data?.draft?.recipients || []).map(contact => <Chip
          style={{marginRight: 10, marginBottom: 10, marginTop: 6}}
          label={contact.displayName}
          onDelete={(e) => {
            setCurrentMail({
              ...currentMail,
              message_data: {
                ...(currentMail.message_data || {}),
                draft: {
                  ...(currentMail.message_data?.draft || {}),
                  recipients: (currentMail.message_data?.draft?.recipients || []).filter(fff => fff.mailAddress !== contact.mailAddress)
                }
              }
            });
          }}
          variant="outlined"
          deleteIcon={undefined}
          color={"primary"}
        />)}
      </Grid>}

      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Button
          label={t(!!addingClient ? "shared.zorg_mail.cta.remove_client" : "shared.zorg_mail.cta.add_client")}
          id="add_client"
          onClick={() => {
            setAddingClient(!addingClient);
          }}
          size='small'
          sx={{
            marginTop: 0
          }}
        />
      </Grid>
      {!!addingClient && <>
        <Grid item xs={6}>
          <TextInput
            id="client_search"
            caption={t("coach.models.appointments.client_search", "Zoek client")}
            value={clientUserSearch}
            backend
            onChange={(e) => {
              setClientUserSearch(e);
            }}
          />
          <Typography sx={{fontSize: '0.7rem', fontStyle: 'italic', marginBottom: 1}}>{(clients || []).length} {t("general.results_found")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Select
            fullWidth
            caption={t("shared.zorg_mail.linked_client", "Gelinkte client")}
            displayEmpty
            backend
            id="recipient"
            value={currentMail.message_data?.draft?.linked_client?.id || ''}
            setValue={(v) => {
              let foundClient = (clients || []).filter(fff => fff.id === parseInt(v.toString(), 10))[0];

              setCurrentMail({
                ...currentMail,
                message_data: {
                  ...(currentMail.message_data || {}),
                  draft: {
                    ...(currentMail.message_data?.draft || {}),
                    linked_client: !foundClient ? {} : {
                      ...(currentMail.message_data?.draft?.linked_client || {}),
                      id: foundClient.id,
                      birth_date: !!foundClient?.birth_date ? DateTime.fromFormat(foundClient?.birth_date, "y-LL-dd").toFormat("dd/LL/y") : '',
                      gender: foundClient?.gender === 0 ? "V" : (foundClient?.gender === 1 ? "M" : "O"),
                      man_name: !!foundClient.gender ? foundClient.last_name : '',
                      man_name_pre: foundClient.extra_data?.dutch?.man_name_pre,
                      girl_name: !foundClient.gender ? foundClient.last_name : '',
                      girl_name_pre: foundClient.extra_data?.dutch?.girl_name_pre,
                      voorletters: foundClient.extra_data?.dutch?.voorletters,
                      first_name: foundClient.first_name,
                      bsn: foundClient.national_number,
                      street: foundClient.street,
                      number: foundClient.number,
                      zip: foundClient.zip,
                      city: foundClient.city,
                      province: foundClient.extra_data?.dutch?.province,
                      country: foundClient?.country_name
                    }
                  }
                }
              });
            }}
          >
            <MenuItem value="">------</MenuItem>
            {(clients || []).map(client => <MenuItem value={client.id}>{client.full_name} <span style={{color: 'rgba(0, 0, 0, 0.5)', marginLeft: 8, fontSize: '0.9rem'}}>({client.email})</span></MenuItem>)}
          </Select>
        </Grid>
        

        <Grid item xs={1}>
          <Box sx={{
            width: '5px',
            height: '100%',
            backgroundColor: (
              !!currentMail.message_data?.draft?.linked_client?.birth_date && 
              !!currentMail.message_data?.draft?.linked_client?.gender && 
              !!currentMail.message_data?.draft?.linked_client?.street && 
              !!currentMail.message_data?.draft?.linked_client?.number && 
              !!currentMail.message_data?.draft?.linked_client?.city && (
                currentMail.message_data?.draft?.linked_client?.gender === "V" ? (!!currentMail.message_data?.draft?.linked_client?.girl_name) : (!!currentMail.message_data?.draft?.linked_client?.man_name)
              )
            ) ? theme.palette.primary.main : theme.palette.warning.main,
            float: 'right',
            marginRight: 1
          }}></Box>
        </Grid>
        <Grid container spacing={1} item xs={11}>

          <Grid item xs={12} md={4}>
            <Typography variant="caption">{t("shared.zorg_mail.linked_client.birth_date")}</Typography>
            <DatePicker
              label={t("shared.zorg_mail.linked_client")}
              disableFuture
              openTo="year"
              format="DD"
              views={["year", "month", "day"]}
              id="birth_day"
              noIcon
              value={currentMail.message_data?.draft?.linked_client?.birth_date || ''}
              setValue={(v) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        birth_date: v
                      }
                    }
                  }
                });
              }}
              sx={{
                box: {
                  width: 'auto',
                  display: 'inline-block'
                },
                field_box: {
                  "svg": {
                    display: 'none'
                  }
                },
                field: {
                  width: 'auto',
                  backgroundColor: 'white',
                  marginTop: 0,
                  "input": {
                    textAlign: 'center'
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Select
              fullWidth
              caption={t("shared.zorg_mail.linked_client.gender", "Geslacht")}
              displayEmpty
              id="gender"
              starred
              backend
              value={currentMail.message_data?.draft?.linked_client?.gender || 'O'}
              setValue={(v) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        gender: v?.toString()
                      }
                    }
                  }
                });
              }}
            >
              <MenuItem value="V">{t("general.genders.female")}</MenuItem>
              <MenuItem value="M">{t("general.genders.male")}</MenuItem>
              <MenuItem value="O">{t("general.genders.other")}</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              id="national_number"
              caption={t("shared.zorg_mail.linked_client.national_number")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.bsn || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        bsn: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextInput
              id="voorletters"
              caption={t("shared.zorg_mail.linked_client.voorletters")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.voorletters || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        voorletters: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              id="first_name"
              caption={t("shared.zorg_mail.linked_client.first_name")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.first_name || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        first_name: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          {currentMail.message_data?.draft?.linked_client?.gender === "V" && <>
            <Grid item xs={12} md={2}>
              <TextInput
                id="girl_name_pre"
                caption={t("shared.zorg_mail.linked_client.girl_name_pre")}
                backend
                value={currentMail?.message_data?.draft?.linked_client?.girl_name_pre || ''}
                onChange={(e) => {
                  setCurrentMail({
                    ...currentMail,
                    message_data: {
                      ...(currentMail.message_data || {}),
                      draft: {
                        ...(currentMail.message_data?.draft || {}),
                        linked_client: {
                          ...(currentMail.message_data?.draft?.linked_client || {}),
                          girl_name_pre: e
                        }
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInput
                id="girl_name"
                caption={t("shared.zorg_mail.linked_client.girl_name")}
                backend
                starred
                value={currentMail?.message_data?.draft?.linked_client?.girl_name || ''}
                onChange={(e) => {
                  setCurrentMail({
                    ...currentMail,
                    message_data: {
                      ...(currentMail.message_data || {}),
                      draft: {
                        ...(currentMail.message_data?.draft || {}),
                        linked_client: {
                          ...(currentMail.message_data?.draft?.linked_client || {}),
                          girl_name: e
                        }
                      }
                    }
                  });
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}></Grid>
          </>}
          <Grid item xs={12} md={2}>
            <TextInput
              id="man_name_pre"
              caption={t(currentMail.message_data?.draft?.linked_client?.gender === "V" ? "shared.zorg_mail.linked_client.man_name_pre_woman" : "shared.zorg_mail.linked_client.man_name_pre")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.man_name_pre || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        man_name_pre: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              id="man_name"
              caption={t(currentMail.message_data?.draft?.linked_client?.gender === "V" ? "shared.zorg_mail.linked_client.man_name_woman" : "shared.zorg_mail.linked_client.man_name")}
              backend
              starred={currentMail.message_data?.draft?.linked_client?.gender !== "V"}
              value={currentMail?.message_data?.draft?.linked_client?.man_name || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        man_name: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={8}>
            <TextInput
              id="street"
              caption={t("shared.zorg_mail.linked_client.street")}
              backend
              starred
              value={currentMail?.message_data?.draft?.linked_client?.street || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        street: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              id="number"
              caption={t("shared.zorg_mail.linked_client.number")}
              backend
              starred
              value={currentMail?.message_data?.draft?.linked_client?.number || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        number: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              id="zip"
              caption={t("shared.zorg_mail.linked_client.zip")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.zip || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        zip: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <TextInput
              id="city"
              caption={t("shared.zorg_mail.linked_client.city")}
              backend
              starred
              value={currentMail?.message_data?.draft?.linked_client?.city || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        city: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              id="province"
              caption={t("shared.zorg_mail.linked_client.province")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.province || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        province: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              id="country"
              caption={t("shared.zorg_mail.linked_client.country")}
              backend
              value={currentMail?.message_data?.draft?.linked_client?.country || ''}
              onChange={(e) => {
                setCurrentMail({
                  ...currentMail,
                  message_data: {
                    ...(currentMail.message_data || {}),
                    draft: {
                      ...(currentMail.message_data?.draft || {}),
                      linked_client: {
                        ...(currentMail.message_data?.draft?.linked_client || {}),
                        country: e
                      }
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Switcher
              id="save_to_profile"
              caption={t("shared.zorg_mail.save_to_profile")}
              value={!!saveToProfile}
              onChange={(c) => {
                setSaveToProfile(!saveToProfile);
              }}
            />
          </Grid>
        </Grid>
      </>}
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          id="subject"
          caption={t("shared.zorg_mail.subject", "Onderwerp")}
          backend
          value={currentMail?.message_data?.draft?.subject || ''}
          onChange={(e) => {
            setCurrentMail({
              ...currentMail,
              message_data: {
                ...(currentMail.message_data || {}),
                draft: {
                  ...(currentMail.message_data?.draft || {}),
                  subject: e
                }
              }
            });
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          caption={t("shared.zorg_mail.body", "Inhoud")}
          value={currentMail?.message_data?.draft?.content || ''}
          multiline
          backend
          minRows={3}
          onChange={(e) => {
            setCurrentMail({
              ...currentMail,
              message_data: {
                ...(currentMail.message_data || {}),
                draft: {
                  ...(currentMail.message_data?.draft || {}),
                  content: e
                }
              }
            });
          }}
        />
      </Grid>

      {/* <Grid item xs={12}>
        {!flickerEditor && <Editor
          advanced
          height={300}
          label={t("shared.zorg_mail.body", "Inhoud")}
          value={currentMail?.message_data?.draft?.content || ''}
          onChange={(e) => {
            setCurrentMail({
              ...currentMail,
              message_data: {
                ...(currentMail.message_data || {}),
                draft: {
                  ...(currentMail.message_data?.draft || {}),
                  content: e
                }
              }
            });
          }}
        />}
      </Grid> */}

      {/* <Grid item xs={12} sx={{marginTop: 2}}>
        <Typography sx={{fontSize: '14px'}}>{t("shared.zorg_mail.attachments", "Bijlagen")}</Typography>
        <FileDrop
          onDrop={acceptedFiles => {setItems(acceptedFiles);}}
          multiple={true}
          maxSize={10 * 1000 * 1000}
          items={items}
          dropText="Click/Drop"
          dropHint="All.: all files, < 10mb"
        />
        {savedItems.length > 0 && <Typography sx={{fontSize: '0.7rem'}}>{t("shared.zorg_mail.attachments", "Bijlagen")}</Typography>}
        {savedItems.map(item => <Tooltip title={<Box sx={{maxWidth: 300, maxHeight: 300}}><img src={item.get_item} style={{maxWidth: 280, maxHeight: 280, width: 'auto', height: 'auto'}} /></Box>}><Chip label={item.item_file_name} variant="outlined" color="primary" sx={{marginRight: 0.5}} onDelete={() => {setSavedItems(savedItems.filter(fff => fff.id !== item.id));}} /></Tooltip>)}
      </Grid> */}

      {/* <Grid item xs={12}>
        <Divider sx={{marginBottom: 1}} />
        <Switcher
          id="send_recipient_email"
          caption={t("shared.zorg_mail.send_recipient_email", "Stuur een herinneringsemail naar de ontvanger")}
          value={!!currentMail?.send_email}
          onChange={(c) => {
            setCurrentMail({
              ...currentMail,
              send_email: c
            });
          }}
        />
      </Grid> */}

      <Grid item xs={12}>
        <Divider />
        {mutationCustomAction.isPending && <CircularProgress sx={{marginTop: 1}} />}
        {!mutationCustomAction.isPending && <Button
          contained
          id="send"
          disabled={(currentMail.message_data?.draft?.recipients || []).length < 1}
          sx={{
            marginTop: 1
          }}
          onClick={(e) => {
            saveMail(true, true);
          }}
          label={t("shared.zorg_mail.send", "Verzenden")}
        />}
        {!mutationCustomAction.isPending && <Button
          contained
          id="draft"
          disabled={(currentMail.message_data?.draft?.recipients || []).length < 1}
          sx={{
            marginTop: 1,
            marginLeft: 1
          }}
          onClick={(e) => {
            saveMail(true);
          }}
          label={t("shared.zorg_mail.save_draft", "Opslaan als draft")}
        />}
        {!mutationCustomAction.isPending && !currentMail?.sent && !!currentMail?.id && <Button
          contained
          id="delete"
          sx={{
            marginTop: 1,
            marginLeft: 1
          }}
          secondary
          onClick={(e) => {
            mutationDelete.mutate({formData: {
              object: 'zorg_mail',
              id: currentMail.id,
              ob: {
                id: currentMail.id,
              }
            }});
          }}
          label={t("shared.zorg_mail.delete_draft", "Draft verwijderen")}
        />}
        {!mutationCustomAction.isPending && <Button
          label={t("shared.buttons.cancel")}
          id='cancel'
          text
          // contained
          onClick={(v) => {
            navigate("/zorgmail_inbox");
          }}
          sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
        />}
      </Grid>

    </Grid>



    <Base
      name="addContact"
      hidden={!addContact}
      maxWidth="md"
      content={<Grid container spacing={1}>
        <Grid container spacing={1} xs={12} sx={{alignContent: 'baseline', paddingLeft: 0.5}}>
          <Grid item xs={12}>
            <Typography variant="h4">{t("shared.zorg_mail.find_contact")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextInput
              id="filter"
              caption={t("shared.zorg_mail.search.contact_name", "Filter op naam")}
              value={clientSearch || ''}
              onChange={(e) => {
                setClientSearch(e);
              }}
            />
          </Grid>
          {(zmContacts || []).length === 0 && <Grid item xs={12}>
            <Box sx={{textAlign: 'center'}}>
              <Typography sx={{fontStyle: 'italic', fontSize: '0.7rem', color: theme.palette.secondary.main}}>{t("general.no_results_found")}</Typography> 
            </Box>
          </Grid>}
          {(zmContacts || []).length > 0 && (zmContacts || []).length < 100 && <Grid item xs={12}>
            <Box sx={{textAlign: 'center'}}>
              <Typography sx={{fontStyle: 'italic', fontSize: '0.7rem', color: theme.palette.secondary.main}}>{t("general.x_results_found", {count: (zmContacts || []).length})}</Typography> 
            </Box>
          </Grid>}
          {(zmContacts || []).length >= 100 && <Grid item xs={12}>
            <Box sx={{textAlign: 'center'}}>
              <Typography sx={{fontStyle: 'italic', fontSize: '0.7rem', color: theme.palette.secondary.main}}>{t("general.100plus_results_found", {count: (zmContacts || []).length})}</Typography> 
            </Box>
          </Grid>}
          {!!mutationCustomAction?.isPending && <Grid item xs={12}>
            <Box sx={{textAlign: 'center'}}>
              <CircularProgress />
            </Box>
          </Grid>}
          {/* {
    "id": "800124193",
    "displayName": "J. Steinmetz (Enovation)",
    "mailAddressEmail": "j.steinmetz@zorgmail.nl",
    "role": "Medewerker",
    "gender": "M",
    "surname": "Steinmetz",
    "initials": "J.",
    "organizationId": "7912",
    "organizationType": "ICT Service Provider",
    "organization": "Enovation",
    "street": "Rivium Quadrant",
    "houseNumber": "2",
    "postalCode": "2909 LC",
    "locality": "CAPELLE AAN DEN IJSSEL",
    "country": "Nederland",
    "chat": true
} */}
          {(zmContacts || []).length > 0&& (zmContacts || []).slice((page * 10), ((page * 10) + 10)).map(contact => <Grid item xs={12}>
            <Box sx={{
              border: '1px solid transparent',
              borderColor: theme.palette.primary.main,
              padding: 1,
              borderRadius: 1
            }}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography>{contact.displayName}</Typography>
                </Grid>
                <Grid item xs={12} sx={{textAlign: 'left'}}>
                  {!!contact.locality && <Typography>{contact.postalCode} {contact.locality}</Typography>}
                </Grid>
                <Grid item xs={12} sx={{textAlign: 'right'}}>
                  <Button
                    contained
                    id="choose"
                    disabled={(currentMail.message_data?.draft?.recipients || []).filter(fff => fff.mailAddress === contact.mailAddress).length > 0}
                    sx={{
                      marginLeft: 1,
                      marginTop: 0
                    }}
                    onClick={(e) => {
                      setCurrentMail({
                        ...currentMail,
                        message_data: {
                          ...(currentMail.message_data || {}),
                          draft: {
                            ...(currentMail.message_data?.draft || {}),
                            recipients: [...(currentMail.message_data?.draft?.recipients || []), contact]
                          }
                        }
                      });
                      setAddContact(false);
                    }}
                    size="small"
                    label={t("shared.zorg_mail.search.use_contact", "Ontvanger toevoegen")}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>)}
          {(zmContacts || []).length > 10 && <Grid item xs={12}>
            <Stack spacing={2} alignItems="center">
              <Pagination count={Math.ceil((zmContacts || []).length/10)} page={page + 1} onChange={(e, v) => {setPage(v - 1);}} boundaryCount={2} siblingCount={2} />
            </Stack>
          </Grid>}
        </Grid>
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setAddContact(false);}}>{t("coach.general.actions.cancel")}</Btn>
      </DialogActions>}
      open={addContact}
      setOpen={setAddContact}
    />
  </Page>;
}

